import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  textDecorationNone: {
    textDecoration: 'none',
  },
  svgImage: {
    width: 20,
    height: 20,
  },
  containerMargin: {
    marginRight: 15,
  },
}));
